import { ReactNode } from "react";
import { useAppVersionGate } from "@/hooks/useAppVersionGate";
import MandatoryUpdateScreen from "@/components/MandatoryUpdateScreen";

export default function AppVersionGate({ children }: { children: ReactNode }) {
  const { status, currentVersion, config } = useAppVersionGate();

  if (status === "update_required" && config) {
    return <MandatoryUpdateScreen currentVersion={currentVersion} config={config} />;
  }

  return <>{children}</>;
}
